import React from "react";
import { Box } from "@mui/material";
import layoutBg from "./../../../assets/images/layoutBg.jpg";
const headerHeight = "62px";
function CustomizationLandingPageLayout({ children }) {
  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          gap: "24px",
        }}
      >
        {children}
      </Box>
    </>
  );
}
export { headerHeight };

export default CustomizationLandingPageLayout;
